
import { Component, Prop, Vue } from 'vue-property-decorator'
import InfoHighlight from './info-highlight.vue'

@Component({
  components: {
    InfoHighlight
  }
})
export default class SearchPopover extends Vue {
    @Prop()
    list!: Array<any>

    @Prop()
    text!: string

    onClick (obj: any) {
      this.$emit('select', obj)
    }

    onClickOutside() {
      this.$emit('clickOutside')
    }
}
